import { useEffect } from 'react';
import { CloudOff, X } from 'lucide-react';
import { api } from '@/lib/api';
import { dismissOutage, outageVisible, useServiceHealth } from '@/lib/service-health';

/**
 * شريطُ العطل المؤقت — يظهر بعد سقوطين متتاليين ويختفي وحده مع أول نجاح (`lib/service-health.ts`).
 * وما دام ظاهراً يسأل `/health` كل خمس ثوانٍ: الصفحةُ المخزَّنة لا تطلب شيئاً فلا يعرف أحدٌ أن الخادم
 * عاد — والشريطُ الذي يقول «نعيد المحاولة» يعيدها فعلاً.
 */
export function ServiceBanner() {
  const h = useServiceHealth();
  const visible = outageVisible(h);
  const down = h.failures >= 2;
  useEffect(() => {
    if (!down) return;
    const id = window.setInterval(() => { void api.get('/health', { anonymous: true }).catch(() => undefined); }, 5000);
    return () => window.clearInterval(id);
  }, [down]);
  if (!visible) return null;
  return (
    <div className="service-banner" role="status" aria-live="polite" data-testid="service-banner">
      <CloudOff size={18} aria-hidden />
      <span className="grow">
        {h.lastWriteFailed
          ? 'نواجه عطلاً مؤقتاً — لم يُحفظ آخرُ إجراء. أعد المحاولة بعد قليل.'
          : 'نواجه عطلاً مؤقتاً — قد لا تظهر بعض البيانات الآن. نعيد المحاولة تلقائياً.'}
      </span>
      <button type="button" className="icon-btn" onClick={dismissOutage} aria-label="أخفِ التنبيه"><X size={16} aria-hidden /></button>
    </div>
  );
}
